import React from 'react';
import './Barranquilla.css'; 

const Barranquilla = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKBQ.pdf" target="_blank" rel="noreferrer">Aeropuerto Ernesto Cortissoz</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontainerBAQ'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 05</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/DARN4B.pdf" target="_blank" rel="noreferrer">DARN4B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/DARN4B.pdf" target="_blank" rel="noreferrer">EGOK2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/DARN4B.pdf" target="_blank" rel="noreferrer">ENTI2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/DARN4B.pdf" target="_blank" rel="noreferrer">ISOT3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/DARN4B.pdf" target="_blank" rel="noreferrer">STA4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/DARN4B.pdf" target="_blank" rel="noreferrer">TIGR2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/DARN4B.pdf" target="_blank" rel="noreferrer">UMKI2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/DARN4B.pdf" target="_blank" rel="noreferrer">VUMB2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG3E.pdf" target="_blank" rel="noreferrer">CTG3E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG3E.pdf" target="_blank" rel="noreferrer">EDRE3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG3E.pdf" target="_blank" rel="noreferrer">MORG3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG3E.pdf" target="_blank" rel="noreferrer">KAKU2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG3E.pdf" target="_blank" rel="noreferrer">VARO3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/BAQ2F.pdf" target="_blank" rel="noreferrer">BAQ2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/EVPI2A.pdf" target="_blank" rel="noreferrer">EVPI2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/NINL2A.pdf" target="_blank" rel="noreferrer">NINL2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/NINL3A.pdf" target="_blank" rel="noreferrer">NINL3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/NINL3A.pdf" target="_blank" rel="noreferrer">GEGI1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/NINL3A.pdf" target="_blank" rel="noreferrer">UTGO1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/NINL3A.pdf" target="_blank" rel="noreferrer">ANLU1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/BAQ2H.pdf" target="_blank" rel="noreferrer">BAQ2H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG2F.pdf" target="_blank" rel="noreferrer">CTG2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG2F.pdf" target="_blank" rel="noreferrer">VARO2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG2F.pdf" target="_blank" rel="noreferrer">KAKU1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG2F.pdf" target="_blank" rel="noreferrer">VOVL2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG2F.pdf" target="_blank" rel="noreferrer">UGRE2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG2F.pdf" target="_blank" rel="noreferrer">SINO1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG2F.pdf" target="_blank" rel="noreferrer">SUST1A</a></th>
          </tr>
          
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 23</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/BAQ2H.pdf" target="_blank" rel="noreferrer">BAQ2H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">CTG1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">DARN1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">EGOK1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">ENTI1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">GEGI1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">LOKO1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">KAKU1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">SINO1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">SUST1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">VOVL1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">UGRE1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1G.pdf" target="_blank" rel="noreferrer">VARO1H</a></th>
          </tr>

          </table>
        </div> 
      </div>

      <div className='subcontainerBAQ'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 05</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/KAKU1E.pdf" target="_blank" rel="noreferrer">KAKU1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/KAKU1E.pdf" target="_blank" rel="noreferrer">MORG1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/KAKU1E.pdf" target="_blank" rel="noreferrer">VARO1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/ISOT5A.pdf" target="_blank" rel="noreferrer">ISOT5A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/VOVL4A.pdf" target="_blank" rel="noreferrer">VOVL4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/ENTI4A.pdf" target="_blank" rel="noreferrer">ENTI4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/ENTI4A.pdf" target="_blank" rel="noreferrer">STA6A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">CTG1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">DARN1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">EDRE1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">EGOK1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">ENTI3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">KAKU2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">LOLU1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">MORG1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">STA2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">UGRE1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">UGSO1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">UMKI1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">VARO2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1A.pdf" target="_blank" rel="noreferrer">VUMB1A</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 23</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/KAKU1E.pdf" target="_blank" rel="noreferrer">KAKU1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/KAKU1E.pdf" target="_blank" rel="noreferrer">MORG1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/KAKU1E.pdf" target="_blank" rel="noreferrer">VARO1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/ISOT5A.pdf" target="_blank" rel="noreferrer">ISOT5A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/VOVL4A.pdf" target="_blank" rel="noreferrer">VOVL4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/ENTI4A.pdf" target="_blank" rel="noreferrer">ENTI4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/ENTI4A.pdf" target="_blank" rel="noreferrer">STA6A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">CTG1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">DARN1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">EDRE1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">EGOK1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">ENTI1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">KAKU1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">LOLU1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">MORG1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">STA2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">UGRE1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">UGSO1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">UMKI1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">VARO1J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/CTG1H.pdf" target="_blank" rel="noreferrer">VUMB1E</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontainerBAQ'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 05</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/ILSY05.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/ILSZ05.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/RNP05.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/LOC05.pdf" target="_blank" rel="noreferrer">LOC</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/VOR05.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>

          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 23</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/RNP23.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/VORA23.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBQ/VORB23.pdf" target="_blank" rel="noreferrer">VOR B</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Barranquilla;